import { ComponentProps, useState } from 'react';
import { CompanyFilterResponse } from '@mercator-gcp/types/elastic_search_service/CompanyFilter';
import Table from 'components/layout/Table';
import SaveCompanyToGroupModal from 'components/widgets/CompanyDetails/SaveCompanyToGroupModal';
import TableBody from 'components/widgets/CompanySearch/Table/Body';
import TableHeader from 'components/widgets/CompanySearch/Table/Header';

const tableStyle = {
  border: 'none',
  overflowX: 'unset',
  overflowY: 'unset',
  height: '100%',
  width: '100%',
};

type Props = ComponentProps<typeof Table> & {
  companyList?: CompanyFilterResponse['results'];
  isLoading: boolean;
};

const CompanySearchTable = ({ companyList, isLoading, ...props }: Props) => {
  const [selectedCompanyId, setSelectedCompanyId] = useState<number | undefined>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [justSavedCompanyId, setJustSavedCompanyId] = useState<number | null>(null);

  const handleOpenModal = (companyId: number) => {
    setSelectedCompanyId(companyId);
    setIsModalOpen(true);
  };

  const clearJustSaved = () => setJustSavedCompanyId(null);

  const handleSaveSuccess = () => {
    setIsModalOpen(false);
    setSelectedCompanyId(undefined);
    if (selectedCompanyId) {
      setJustSavedCompanyId(selectedCompanyId);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCompanyId(undefined);
  };

  if (!companyList && !isLoading) {
    return null;
  }

  return (
    <>
      <Table sx={tableStyle} aria-label="company search results table" {...props}>
        <TableHeader />
        <TableBody
          items={companyList}
          isLoading={isLoading}
          onOpenSaveModal={handleOpenModal}
          justSavedCompanyId={justSavedCompanyId}
          clearJustSaved={clearJustSaved}
        />
      </Table>
      {selectedCompanyId && (
        <SaveCompanyToGroupModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onSuccess={handleSaveSuccess}
          companyId={selectedCompanyId}
        />
      )}
    </>
  );
};

export default CompanySearchTable;
